import React from 'react';
import { getDeviationType, isGifDeviation } from '../../../../../_helpers';
import { DeviationTypes } from '../../../../../../types/deviation';
import DeviationTypeFilm from '../../../../../../Icons/DeviationType/Film';
import DeviationTypeGif from '../../../../../../Icons/DeviationType/Gif';
import { IconSize } from '../../../../../../Icons/IconWrap';
var MediaIcon = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    var type = getDeviationType(deviation);
    switch (type) {
        case DeviationTypes.FILM:
            return React.createElement(DeviationTypeFilm, { size: IconSize.MEDIUM, className: className });
        case DeviationTypes.IMAGE:
            if (isGifDeviation(deviation)) {
                return (React.createElement(DeviationTypeGif, { size: IconSize.MEDIUM, className: className }));
            }
            return null;
        default:
            return null;
    }
};
MediaIcon.displayName = 'MediaIcon';
export default MediaIcon;
//# sourceMappingURL=MediaIcon.js.map